module.exports = __webpack_public_path__ + "img/INTERIOR-S-CROSS-2.4a62a4ff.jpg";